import { motion } from 'framer-motion';
import { ArrowRight, Globe2, Sparkles, Users, Briefcase, Award } from 'lucide-react';
import './Clients.css';
import {
    HKM1, hayySoft_System, Arribatec, DataScal, RPA, SmartParley, Wisr1, RightHub, Netwrkai, Marksmen, WkUp,
    Accurants, Deep, Sproutly, LittlegayBook, Leadx1, YieldSec, Skyler, AppSavi, NeuroFlash, Aviat, TomorrowThings, BeyondBeauty, LTIN1, HelathMotivate
} from "../../../theme/images";
import { Link } from 'react-router-dom';
const fadeUp = { hidden: { opacity: 0, y: 26 }, visible: { opacity: 1, y: 0 } };
const stagger = { visible: { transition: { staggerChildren: 0.07 } } };

const clients = [
    { name: 'Aviat', tag: 'AI', country: 'Germany', img: Aviat },
    { name: 'Tomorrow Things', tag: 'AI', country: 'Germany', img: TomorrowThings },
    { name: 'BeyondBeauty', tag: 'AI', country: 'Germany', img: BeyondBeauty },
    { name: 'LTIN', tag: 'AI', country: 'Switzerland', img: LTIN1 },
    { name: 'HelathMotivate', tag: 'AI', country: 'USA', img: HelathMotivate },
    { name: 'HeineKing Media', tag: 'Media', country: 'Germany', img: HKM1 },
    { name: 'Hayysoft', tag: 'Software', country: 'Singapore', img: hayySoft_System },
    { name: 'Arribatec', tag: 'Consulting', country: 'Norway', img: Arribatec },
    { name: 'DataScale', tag: 'Data', country: 'USA', img: DataScal },
    { name: 'LittleGay Book', tag: 'Social', country: 'USA', img: LittlegayBook },
    { name: 'RPA Solutions', tag: 'Automation', country: 'USA', img: RPA },
    { name: 'SmartParle', tag: 'Edu-Tech', country: 'Germany', img: SmartParley },
    { name: 'Wisr', tag: 'Fintech', country: 'Norway', img: Wisr1 },
    { name: 'RightHub', tag: 'Legal-Tech', country: 'Sweden', img: RightHub },
    { name: 'Netwrk', tag: 'Networking', country: 'Canada', img: Netwrkai },
    { name: 'Marksmen', tag: 'Marketing', country: 'Norway', img: Marksmen },
    { name: 'WakeUpAs', tag: 'Wellness', country: 'UAE', img: WkUp },
    { name: 'Accurants', tag: 'Accounting', country: 'USA', img: Accurants },
    { name: 'Deeep AI', tag: 'AI', country: 'USA', img: Deep },
    { name: 'Spreauty', tag: 'Beauty', country: 'USA', img: Sproutly },
    { name: 'LeadX', tag: 'Sales', country: 'Norway', img: Leadx1 },
    { name: 'Yield', tag: 'Finance', country: 'USA', img: YieldSec },
    { name: 'Skyler', tag: 'SaaS', country: 'Ireland', img: Skyler },
    { name: 'AppSavi', tag: 'Mobile Apps', country: 'USA', img: AppSavi },
    { name: 'NeuroFlash', tag: 'AI', country: 'Germany', img: NeuroFlash },
    

];

const heroShots = [
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&q=80',
    'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&q=80',
    'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=600&q=80',
    'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&q=80',
];

const stats = [
    { value: '40+', label: 'Satisfied Clients', icon: Users },
    { value: '75+', label: 'Projects Shipped', icon: Briefcase },
    { value: '10+', label: 'Countries', icon: Globe2 },
    { value: '98%', label: 'Satisfaction', icon: Award },
];

const Clients = () => {
    return (
        <div className="clients-page">
            {/* HERO */}
            <section className="cl-hero">
                <div className="cl-hero__blob cl-hero__blob--g" />
                <div className="cl-hero__blob cl-hero__blob--b" />
                <div className="cl-hero__inner container">
                    <motion.div initial="hidden" animate="visible" variants={stagger}>
                        <motion.span className="cl-hero__eyebrow" variants={fadeUp} transition={{ duration: 0.5 }}>
                            <Sparkles size={14} /> Our Clients
                        </motion.span>
                        <motion.h1 className="cl-hero__title" variants={fadeUp} transition={{ duration: 0.7 }}>
                            Brands that <span className="accent-g">trust us</span> to build, scale and ship <span className="accent-b">faster.</span>
                        </motion.h1>
                        <motion.p className="cl-hero__sub" variants={fadeUp} transition={{ duration: 0.6, delay: 0.1 }}>
                            From bold startups to global enterprises — we partner with teams across the world to design, engineer and grow products people love.
                        </motion.p>
                        <motion.div className="cl-hero__actions" variants={fadeUp} transition={{ duration: 0.6, delay: 0.2 }}>
                            <a href="#cl-clients" className="cl-btn cl-btn--primary">
                                Meet our Clients <ArrowRight size={18} />
                            </a>
                            <Link to="/client-testimonies" className="cl-btn cl-btn--ghost">Read Testimonials</Link>
                        </motion.div>
                    </motion.div>

                    {/* Hero collage */}
                    <motion.div
                        className="cl-hero__collage"
                        initial={{ opacity: 0, scale: 0.92 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.9, ease: 'easeOut' }}
                    >
                        {heroShots.map((src, i) => (
                            <div key={src} className={`cl-hero__tile cl-hero__tile--${i + 1}`}>
                                <img src={src} alt="Client team" loading="lazy" />
                            </div>
                        ))}
                        <div className="cl-hero__badge">
                            <strong>20+</strong>
                            <span>Global brands</span>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* STATS */}
            <section className="cl-stats">
                <motion.div
                    className="cl-stats__grid"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={stagger}
                >
                    {stats.map((s) => {
                        const Icon = s.icon;
                        return (
                            <motion.div key={s.label} className="cl-stat" variants={fadeUp} transition={{ duration: 0.5 }}>
                                <div className="cl-stat__icon"><Icon size={22} /></div>
                                <div className="cl-stat__num">{s.value}</div>
                                <div className="cl-stat__label">{s.label}</div>
                            </motion.div>
                        );
                    })}
                </motion.div>
            </section>

            {/* INDUSTRY CHIPS */}
            <section className="cl-filter" id="cl-clients">
                <motion.div
                    className="cl-section-head"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUp}
                    transition={{ duration: 0.6 }}
                >
                    <span className="cl-section-tag">Trusted by Businesses Worldwide</span>
                    <h2>Your technology partner for growth and innovation</h2>
                    <p>We help organizations transform ideas into powerful digital solutions through expert engineering, modern technologies, and a commitment to excellence.</p>
                </motion.div>
                {/* <div className="cl-chips">
          {industries.map((i, idx) => (
            <button key={i} className={`cl-chip ${idx === 0 ? 'is-active' : ''}`}>{i}</button>
          ))}
        </div> */}
            </section>

            {/* CLIENT GRID */}
            <section className="cl-grid-section container">
                <motion.div
                    className="cl-grid"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.05 }}
                    variants={stagger}
                >
                    {clients.map((c) => (
                        <motion.article
                            key={c.name}
                            className="cl-card"
                            variants={fadeUp}
                            transition={{ duration: 0.5 }}
                            whileHover={{ y: -8 }}
                        >
                            <div className="cl-card__media">
                                <img src={c.img} alt={c.name} loading="lazy" />
                                <span className="cl-card__tag">{c.country}</span>
                            </div>
                            {/* <div className="cl-card__body">
                <h3>{c.name}</h3>
                <div className="cl-card__meta">
                  <MapPin size={13} /> {c.country}
                </div>
                <a className="cl-card__link" href="/case-study">
                  View work <ArrowRight size={14} />
                </a>
              </div> */}
                        </motion.article>
                    ))}
                </motion.div>
            </section>

            {/* QUOTE STRIP */}
            {/* <section className="cl-quote">
                <motion.div
                    className="cl-quote__inner"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <div className="cl-quote__mark">“</div>
                    <p className="cl-quote__text">
                        SpringUp Labs has been an extension of our team — fast, thoughtful and genuinely invested in the outcome. They turn ideas into shipped products.
                    </p>
                    <div className="cl-quote__author">
                        <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80" alt="Author" />
                        <div>
                            <strong>Daniel R.</strong>
                            <span>Product Leader · Long-standing client</span>
                        </div>
                    </div>
                </motion.div>
            </section> */}

            {/* CTA */}
            <section className="cl-cta container">
                <motion.div
                    className="cl-cta__card "
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <div>
                        <h2>Ready to join our growing family?</h2>
                        <p>Whether you're validating an idea or scaling a global product, we're here to help you ship with confidence.</p>
                        <div className="cl-cta__actions">
                            <Link to="/contact" className="cl-btn cl-btn--primary">Get Started <ArrowRight size={18} /></Link>
                            <Link to="/insights/case-study" className="cl-btn cl-btn--ghost">View Case Studies</Link>
                        </div>
                    </div>
                    <div className="cl-cta__visual">
                        {clients.slice(0, 6).map((c) => (
                            <img key={c.name} src={c.img} alt={c.name} loading="lazy" />
                        ))}
                    </div>
                </motion.div>
            </section>
        </div>
    );
};

export default Clients;